import { ReactNode, createElement } from 'react';

export interface NavigationLinkConfig {
  id: string;
  label: string;
  path: string;
  icon?: ReactNode;
  requiresBlog?: boolean;
  isActive: (pathname: string) => boolean;
}

const svg = (pathD: string) =>
  createElement(
    'svg',
    { className: 'w-5 h-5', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' },
    createElement('path', {
      d: pathD,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 2,
    })
  );

const navigationLinks: NavigationLinkConfig[] = [
  {
    id: 'home',
    label: 'Home',
    path: '/',
    icon: svg(
      'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
    ),
    isActive: (pathname: string) => pathname === '/',
  },
  {
    id: 'schedule',
    label: 'Schedule',
    path: '/schedule',
    icon: svg(
      'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
    ),
    isActive: (pathname: string) => pathname === '/schedule',
  },
  {
    id: 'shows',
    label: 'Shows',
    path: '/shows',
    icon: svg(
      'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
    ),
    isActive: (pathname: string) =>
      pathname.startsWith('/shows') || pathname.startsWith('/show'),
  },
  {
    id: 'blog',
    label: 'Blog',
    path: '/blog',
    requiresBlog: true,
    icon: svg(
      'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
    ),
    isActive: (pathname: string) => pathname.startsWith('/blog'),
  },
  {
    id: 'presenters',
    label: 'Presenters',
    path: '/presenters',
    icon: svg(
      'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
    ),
    isActive: (pathname: string) => pathname.startsWith('/presenters'),
  },
  {
    id: 'about',
    label: 'About',
    path: '/about',
    icon: svg('M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'),
    isActive: (pathname: string) => pathname === '/about',
  },
  {
    id: 'store',
    label: 'Store',
    path: '/store',
    icon: svg('M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z'),
    isActive: (pathname: string) => pathname === '/store',
  },
];

export const getNavigationLinks = (includeBlog: boolean): NavigationLinkConfig[] =>
  navigationLinks.filter((link) => (link.requiresBlog ? includeBlog : true));
